import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/conversations/")({
  staticData: {
    breadcrumb: false,
  },
  component: ConversationsIndexRoute,
})

function ConversationsIndexRoute() {
  return null
}
